import React from "react";

import { Row, Col, Dropdown } from "react-bootstrap";

import "../styles/mapPopup.css";
import { fieldNames } from "../utilities/constants";
import utils from "../utilities/utils";

const {
  DISTRICT_REPRESENTED,
  LEGISLATIVE_CONFERENCE,
  IMAGE,
  TITLE,
  FIRST_NAME,
  LAST_NAME,
  CHAIRPERSONSHIP,
  IN_OFFICE_SINCE,
  DISTRICT_OFFICE_ADDRESS,
  DISTRICT_OFFICE_PHONE,
  DISTRICT_OFFICE_FAX,
  CAPITOL_OFFICE_ADDRESS,
  CAPITOL_OFFICE_PHONE,
  CAPITOL_OFFICE_FAX,
  EMAIL,
  WEBSITE,
  PARTY,
  MAP_IMAGE,
  OTHER_OFFICE_ADDRESS,
  OTHER_OFFICE_PHONE,
} = fieldNames;

function MapPopup(props) {
  const legislatorImageAltText = `${props.rep[TITLE]} ${props.rep[FIRST_NAME]} ${props.rep[LAST_NAME]} headshot`;
  const districtImageAltText = `district ${props.rep[DISTRICT_REPRESENTED]} shape`;
  let party = props.rep[PARTY].join(", ");

  let chairpersonship = props.chairpersonship
    ? `Chair of Committee(s): ${props.rep[CHAIRPERSONSHIP]}`
    : null;

  let map_image = props.rep[MAP_IMAGE][0].url ? (
    <img
      src={props.rep[MAP_IMAGE][0].url}
      className="map-image"
      alt={districtImageAltText}
    />
  ) : null;

  let districtOffice =
    !props.rep[DISTRICT_OFFICE_ADDRESS] &&
    !props.rep[DISTRICT_OFFICE_PHONE] &&
    !props.rep[DISTRICT_OFFICE_FAX]
      ? "hide-district-office"
      : "district-office";

  let legislativeOffice =
    !props.rep[CAPITOL_OFFICE_ADDRESS] &&
    !props.rep[CAPITOL_OFFICE_PHONE] &&
    !props.rep[CAPITOL_OFFICE_FAX]
      ? "hide-legislative-office"
      : "legislative-office";

  let otherContactInfo =
    !props.rep[OTHER_OFFICE_ADDRESS] && !props.rep[OTHER_OFFICE_PHONE]
      ? "hide-other-office"
      : "other-office";

  let officialWebsite = props.rep[WEBSITE] ? (
    <a
      href={props.rep[WEBSITE]}
      target="_blank"
      className="official-website"
      rel="noreferrer"
    >
      Official Website
    </a>
  ) : null;

  return props.rep[LAST_NAME] === "Vacant" ? (
    <div className="vacant-person">
      <Row>
        <Col xs={3}>
          <img
            src={props.rep[IMAGE][0].url}
            className="person-img"
            alt="legislator placeholder headshot"
          />
        </Col>
        <Col xs={9}>
          <p className="full-name">
            {props.rep[FIRST_NAME]} {props.rep[LAST_NAME]}
          </p>
        </Col>
      </Row>

      <Row className="district-area">
        <Col xs={3}>{map_image}</Col>
        <Col xs={9}>
          <p className="district-num">
            District {props.rep[DISTRICT_REPRESENTED]}
          </p>
        </Col>
      </Row>
    </div>
  ) : (
    <div className="map-popup-container">
      <Row>
        <Col xs={3}>
          <img
            src={props.rep[IMAGE][0].url}
            className="person-img"
            alt={legislatorImageAltText}
          />
        </Col>
        <Col xs={9}>
          <p className="title-and-in-office-since">
            {props.rep[TITLE]} Since {props.rep[IN_OFFICE_SINCE]}
          </p>
          <p className="full-name">
            {props.rep[FIRST_NAME]} {props.rep[LAST_NAME]} ({party})
          </p>
          <p>{props.rep[LEGISLATIVE_CONFERENCE]}</p>

          {<p>{chairpersonship}</p>}
        </Col>
      </Row>
      <Row className="district-area">
        <Col xs={3}>{map_image}</Col>
        <Col xs={9}>
          <p className="district-num">
            District {props.rep[DISTRICT_REPRESENTED]}
          </p>
        </Col>
      </Row>
      <Dropdown.Divider className="divider" />
      <Row>
        <Col xs={6}>
          <div className={districtOffice}>
            <p className="district-off-title">District Office</p>
            <p className="district-off-addr">
              {props.rep[DISTRICT_OFFICE_ADDRESS]}
            </p>

            <p>
              Tel:{" "}
              <span className="district-off-tel">
                {props.rep[DISTRICT_OFFICE_PHONE]}
              </span>
            </p>
            <p>
              F:{" "}
              <span className="district-off-fax">
                {props.rep[DISTRICT_OFFICE_FAX]}
              </span>
            </p>
          </div>

          <div className={legislativeOffice}>
            <p className="legislative-off-title">Legislative Office</p>
            <p className="legislative-off-addr">
              {props.rep[CAPITOL_OFFICE_ADDRESS]}
            </p>
            <p>
              Tel:{" "}
              <span className="legislative-off-tel">
                {props.rep[CAPITOL_OFFICE_PHONE]}
              </span>
            </p>
            <p>
              F:{" "}
              <span className="legislative-off-fax">
                {props.rep[CAPITOL_OFFICE_FAX]}
              </span>
            </p>
          </div>
          <div className={otherContactInfo}>
            <p className="legislative-off-title">Other Contact Info</p>
            <p className="legislative-off-addr">
              {props.rep[OTHER_OFFICE_ADDRESS]}
            </p>
            <p>
              Tel:{" "}
              <span className="legislative-off-tel">
                {props.rep[OTHER_OFFICE_PHONE]}
              </span>
            </p>
          </div>
        </Col>

        <Col xs={6}>
          <div className="personal-info">
            <p className="email-title">Email: </p>
            <p>
              <a className="email" href={"mailto:" + props.rep[EMAIL]}>
                {props.rep[EMAIL]}
              </a>
            </p>
            {officialWebsite}
            <div>{utils.renderIdentities(props.rep, "bold", false)}</div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default MapPopup;
